import styled from 'styled-components';

import {breakpoints} from '../../../../constants/Breakpoints';

const CrewVBucksLogoContainer = styled.div`
  width: 80%;

  @media screen and ${breakpoints.desktopL} {
    width: 100%;
  }
`;

export default CrewVBucksLogoContainer;
